(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmp-dental-2026"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    const root=document.getElementById('pmp-dental');
    if(!root||root.dataset.ready==='true')return;
    root.dataset.ready='true';
    const form=root.querySelector('.pmp-product-offer-form');
    const radios=Array.from(root.querySelectorAll('input[name="pmp_product_bundle"]'));
    function sync(r){
      if(!r)return;
      root.dataset.selectedQuantity=r.value;
      form.querySelector('[name="quantity"]').value=r.value;
      form.querySelector('[name="properties[Bundle offer]"]').value=r.dataset.offer;
      form.querySelector('[name="properties[_pmp_bundle]"]').value=r.value;
      form.querySelector('[name="properties[_pmp_offer_total_cents]"]').value=r.dataset.totalCents;
      root.querySelector('[data-pmp-summary-offer]').textContent=r.dataset.offer;
      root.querySelector('[data-pmp-summary-total]').textContent=r.dataset.totalFormatted;
    }
    radios.forEach(r=>r.addEventListener('change',()=>sync(r)));
    sync(radios.find(r=>r.checked));
    const slides=Array.from(root.querySelectorAll('[data-pmp-product-slide]'));
    const thumbs=Array.from(root.querySelectorAll('[data-pmp-product-thumb]'));
    let current=0;
    function show(i){
      current=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>{s.hidden=n!==current;});
      thumbs.forEach((t,n)=>{t.setAttribute('aria-current',String(n===current));});
    }
    thumbs.forEach((t,n)=>t.addEventListener('click',()=>show(n)));
    root.querySelector('[data-pmp-product-prev]').addEventListener('click',()=>show(current-1));
    root.querySelector('[data-pmp-product-next]').addEventListener('click',()=>show(current+1));
    root.querySelector('.dd-gallery').addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(current+1);}if(e.key==='ArrowLeft'){e.preventDefault();show(current-1);}});
    let submitting=false;
    form.addEventListener('submit',async e=>{
      e.preventDefault();e.stopImmediatePropagation();if(submitting)return;
      const button=e.submitter||form.querySelector('[type="submit"]');
      if(button.disabled)return;
      const original=button.innerHTML;
      const error=form.querySelector('[data-pmp-error]');
      const variant=Number(form.querySelector('[name="id"]').value);
      const quantity=Number(form.querySelector('[name="quantity"]').value);
      const offer=form.querySelector('[name="properties[Bundle offer]"]').value;
      const total=form.querySelector('[name="properties[_pmp_offer_total_cents]"]').value;
      const upsell=Number(form.dataset.pmpUpsellVariant||0);
      const buy=button.name==='pmp-buy-now';
      let shopRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      if(!shopRoot.endsWith('/'))shopRoot+='/';
      delete form.dataset.pmpUpsellVariant;
      error.hidden=true;submitting=true;button.disabled=true;button.textContent=root.dataset.dentalLoading;
      try{
        const items=[{id:variant,quantity,properties:{'Bundle offer':offer,'_pmp_bundle':String(quantity),'_pmp_offer_total_cents':String(total)}}];
        if(upsell&&upsell!==variant)items.push({id:upsell,quantity:1});
        const response=await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok)throw new Error(root.dataset.dentalError);
        window.location.href=shopRoot+(buy?'checkout':'cart');
      }catch(errorObject){
        error.textContent=root.dataset.dentalError;error.hidden=false;submitting=false;button.disabled=false;button.innerHTML=original;
      }
    },true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmp-product-cinema"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };

    const bundleCopy = (root) => ({
      heading: root.dataset.pmpBundleHeading || 'Select quantity',
      labels: (root.dataset.pmpBundleLabels || '1 unit|2 units|3 + 1 FREE').split('|'),
      badges: (root.dataset.pmpBundleBadges || '|MOST POPULAR|BEST VALUE').split('|'),
      notes: (root.dataset.pmpBundleNotes || 'Single unit · Standard price|2-unit bundle · Save 20%|Buy 3, get 1 free · 4 units total').split('|')
    });

    const bundleIndex = (radio, fallbackIndex) => {
      const quantity = Number.parseInt(radio?.value || '', 10);
      if (quantity === 1) return 0;
      if (quantity === 2) return 1;
      if (quantity === 4 || quantity === 3) return 2;
      return fallbackIndex;
    };

    const updateBundleSummary = (root, items, copy) => {
      const bundler = document.querySelector('#bundler-v3');
      const summary = bundler?.querySelector('[data-pmp-bundle-summary]');
      if (!summary) return;
      const selectedItem = items.find((item) => item.radio.checked) || items[0];
      if (!selectedItem) return;
      const selectedIndex = bundleIndex(selectedItem.radio, selectedItem.fallbackIndex);
      const currentPrice = selectedItem.element.querySelector('.discounted-price')?.textContent?.trim() || '';
      const comparePrice = selectedItem.element.querySelector('.compare-price')?.textContent?.trim() || '';
      const name = summary.querySelector('.pmp-bundle-summary__name');
      const price = summary.querySelector('.pmp-bundle-summary__price');
      const compare = summary.querySelector('.pmp-bundle-summary__compare');
      const note = summary.querySelector('.pmp-bundle-summary__note');
      setText(name, copy.labels[selectedIndex] || copy.labels[0]);
      setText(price, currentPrice);
      if (compare) {
        setText(compare, comparePrice);
        if (compare.hidden !== !comparePrice) compare.hidden = !comparePrice;
      }
      setText(note, copy.notes[selectedIndex] || copy.notes[0]);
    };

    const enhanceBundle = (root) => {
      const bundler = document.querySelector('#bundler-v3');
      const offers = bundler?.querySelector('.atlas-bundler-offers');
      if (!bundler || !offers) return false;
      const items = Array.from(offers.children).map((element, fallbackIndex) => ({
        element,
        fallbackIndex,
        radio: element.querySelector('input.bundle-qty-deal__radio[name="quantity"]'),
        label: element.querySelector('label.bundle-qty-option')
      })).filter((item) => item.radio && item.label).slice(0, 3);
      if (items.length !== 3) return false;

      const copy = bundleCopy(root);
      bundler.classList.add('pmp-bundle-enhanced');
      const heading = bundler.querySelector('.bundle-qty-deal__title');
      setText(heading, copy.heading);

      items.forEach((item) => {
        const selectedIndex = bundleIndex(item.radio, item.fallbackIndex);
        const title = item.label.querySelector('.bundle-qty-title');
        setText(title, copy.labels[selectedIndex] || copy.labels[item.fallbackIndex]);

        let visual = item.label.querySelector('.pmp-bundle-visual');
        if (!visual) {
          visual = document.createElement('span');
          visual.className = 'pmp-bundle-visual';
          const imageCount = Math.min(selectedIndex + 1, 3);
          for (let imageIndex = 0; imageIndex < imageCount; imageIndex += 1) {
            const image = document.createElement('img');
            image.src = root.dataset.pmpBundleImage;
            image.alt = imageIndex === 0 ? root.dataset.pmpBundleAlt : '';
            image.loading = 'eager';
            image.decoding = 'async';
            visual.appendChild(image);
          }
          if (selectedIndex === 2) {
            const extra = document.createElement('span');
            extra.className = 'pmp-bundle-visual__extra';
            extra.textContent = '+1';
            visual.appendChild(extra);
          }
          const details = item.label.querySelector('.bundle-variants-and-price-container');
          (details?.parentElement || item.label).insertBefore(visual, details || item.label.firstChild);
        }

        let badge = item.element.querySelector(':scope > .pmp-bundle-badge');
        const badgeText = copy.badges[selectedIndex] || '';
        if (badgeText && !badge) {
          badge = document.createElement('span');
          badge.className = 'pmp-bundle-badge';
          item.element.appendChild(badge);
        }
        setText(badge, badgeText);

        if (item.label.dataset.pmpBundleBound !== 'true') {
          item.label.dataset.pmpBundleBound = 'true';
          item.label.addEventListener('click', () => {
            window.setTimeout(() => enhanceBundle(root), 0);
            window.setTimeout(() => enhanceBundle(root), 120);
            window.setTimeout(() => enhanceBundle(root), 400);
          });
        }
      });

      let summary = bundler.querySelector('[data-pmp-bundle-summary]');
      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'pmp-bundle-summary';
        summary.dataset.pmpBundleSummary = '';
        summary.setAttribute('aria-live', 'polite');
        summary.innerHTML = '<div class="pmp-bundle-summary__top"><span class="pmp-bundle-summary__dot" aria-hidden="true"></span><strong class="pmp-bundle-summary__name"></strong><b class="pmp-bundle-summary__price"></b><del class="pmp-bundle-summary__compare"></del></div><span class="pmp-bundle-summary__note"></span>';
        offers.insertAdjacentElement('afterend', summary);
      }

      const quantityLabel = document.querySelector('.atlas-quantity-label');
      quantityLabel?.closest('.product-info-header')?.classList.add('pmp-bundle-quantity-hidden');
      updateBundleSummary(root, items, copy);
      return true;
    };

    const watchBundle = (root) => {
      if (root.dataset.pmpBundleWatching === 'true') return;
      root.dataset.pmpBundleWatching = 'true';
      let scheduled = false;
      const refresh = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          enhanceBundle(root);
        });
      };
      const observer = new MutationObserver(refresh);
      observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      document.addEventListener('change', (event) => {
        if (!event.target.matches('#bundler-v3 input.bundle-qty-deal__radio[name="quantity"]')) return;
        refresh();
        window.setTimeout(refresh, 120);
        window.setTimeout(refresh, 400);
      }, true);
      refresh();
      const retry = window.setInterval(refresh, 300);
      window.setTimeout(() => window.clearInterval(retry), 12000);
    };

    const initialize = (root) => {
      if (!root) return;
      watchBundle(root);
      if (root.dataset.pmpPdpReady === 'true') return;
      root.dataset.pmpPdpReady = 'true';
      const buttons = Array.from(root.querySelectorAll('[data-pmp-layer]'));
      const title = root.querySelector('[data-pmp-detail-title]');
      const note = root.querySelector('[data-pmp-detail-note]');
      const index = root.querySelector('[data-pmp-detail-index]');
      const detail = root.querySelector('[role="tabpanel"]');
      const rail = root.querySelector('.pmp-pdp__media-rail');
      const selectLayer = (buttonIndex, moveFocus = false) => {
        const selectedButton = buttons[buttonIndex];
        buttons.forEach((item, itemIndex) => item.setAttribute('aria-selected', itemIndex === buttonIndex ? 'true' : 'false'));
        buttons.forEach((item, itemIndex) => item.setAttribute('tabindex', itemIndex === buttonIndex ? '0' : '-1'));
        if (title) title.textContent = selectedButton?.dataset.title || '';
        if (note) note.textContent = selectedButton?.dataset.note || '';
        if (index) index.textContent = `0${buttonIndex + 1} / 04`;
        if (detail && selectedButton?.id) detail.setAttribute('aria-labelledby', selectedButton.id);
        if (moveFocus) buttons[buttonIndex]?.focus();
      };
      selectLayer(0);
      buttons.forEach((button, buttonIndex) => {
        button.addEventListener('click', () => selectLayer(buttonIndex));
        button.addEventListener('keydown', (event) => {
          let targetIndex = buttonIndex;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = (buttonIndex + 1) % buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = (buttonIndex - 1 + buttons.length) % buttons.length;
          else if (event.key === 'Home') targetIndex = 0;
          else if (event.key === 'End') targetIndex = buttons.length - 1;
          else return;
          event.preventDefault();
          selectLayer(targetIndex, true);
        });
      });
      root.querySelector('[data-pmp-media-prev]')?.addEventListener('click', () => rail?.scrollBy({ left: -Math.max(320, rail.clientWidth * .75), behavior: 'smooth' }));
      root.querySelector('[data-pmp-media-next]')?.addEventListener('click', () => rail?.scrollBy({ left: Math.max(320, rail.clientWidth * .75), behavior: 'smooth' }));
    };
    document.querySelectorAll('[data-pmp-pdp]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-pmp-pdp]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmp-science-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pmp-home]').forEach((root) => {
      if (root.dataset.pmpReady === 'true') return;
      root.dataset.pmpReady = 'true';
      const rail = root.querySelector('[data-pmp-rail]');
      const cards = Array.from(root.querySelectorAll('[data-pmp-card]'));
      const dotsHost = root.querySelector('[data-pmp-dots]');
      const counter = root.querySelector('[data-pmp-counter]');
      let activeCard = 0;
      const goToCard = (index) => {
        if (!rail || !cards.length) return;
        activeCard = (index + cards.length) % cards.length;
        const targetLeft = cards[activeCard].offsetLeft - ((rail.clientWidth - cards[activeCard].offsetWidth) / 2);
        rail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        syncDots();
      };
      const syncDots = () => {
        if (counter) counter.textContent = `Formula ${activeCard + 1} of ${cards.length}`;
        if (dotsHost) Array.from(dotsHost.children).forEach((dot, index) => dot.classList.toggle('is-active', index === activeCard));
      };
      if (dotsHost) cards.forEach((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show formula ${index + 1}`);
        dot.addEventListener('click', () => goToCard(index));
        dotsHost.appendChild(dot);
      });
      root.querySelector('[data-pmp-prev]')?.addEventListener('click', () => goToCard(activeCard - 1));
      root.querySelector('[data-pmp-next]')?.addEventListener('click', () => goToCard(activeCard + 1));
      let frame;
      rail?.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const center = rail.scrollLeft + rail.clientWidth / 2;
          activeCard = cards.reduce((best, card, index) => Math.abs(card.offsetLeft + card.offsetWidth / 2 - center) < Math.abs(cards[best].offsetLeft + cards[best].offsetWidth / 2 - center) ? index : best, 0);
          syncDots();
        });
      }, { passive: true });
      syncDots();

      const autoplayVideos = Array.from(root.querySelectorAll('[data-pmp-autoplay]'));
      const startVideo = (video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.autoplay = true;
        const attempt = () => {
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        };
        if (video.readyState >= 2) attempt();
        else video.addEventListener('canplay', attempt, { once: true });
      };
      autoplayVideos.forEach(startVideo);
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) startVideo(entry.target);
        }), { threshold: 0.12 });
        autoplayVideos.forEach((video) => videoObserver.observe(video));
      }
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) autoplayVideos.forEach(startVideo);
      });

      const heroButtons = Array.from(root.querySelectorAll('[data-pmp-hero-product]'));
      const heroLink = root.querySelector('[data-pmp-hero-link]');
      const heroCode = root.querySelector('[data-pmp-hero-code]');
      const heroLabel = root.querySelector('[data-pmp-hero-label]');
      const heroNote = root.querySelector('[data-pmp-hero-note]');
      heroButtons.forEach((button) => button.addEventListener('click', () => {
        heroButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (heroLink) heroLink.href = button.dataset.url || heroLink.href;
        if (heroCode) heroCode.textContent = button.dataset.code || '';
        if (heroLabel) heroLabel.textContent = `Shop ${button.dataset.label || 'this formula'}`;
        if (heroNote) heroNote.textContent = button.dataset.note || '';
      }));

      const tabs = Array.from(root.querySelectorAll('[data-pmp-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-pmp-panel]'));
      tabs.forEach((tab, index) => tab.addEventListener('click', () => {
        tabs.forEach((item, itemIndex) => item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false'));
        panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
          panel.classList.toggle('is-active', panelIndex === index);
        });
      }));

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        }), { threshold: 0.14 });
        root.querySelectorAll('.pmp-reveal').forEach((item) => observer.observe(item));
      } else {
        root.querySelectorAll('.pmp-reveal').forEach((item) => item.classList.add('is-visible'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["private-task-dashboard"] && !Shopify.designMode) return;
  try {
    
  (()=>{const root=document.querySelector('[data-pmp-tasks]');if(!root||!root.querySelector('[data-calendar-grid]'))return;
  const key='pmp_private_tasks_v1',seedEl=root.querySelector('[data-task-seed]');let tasks=[];try{tasks=JSON.parse(localStorage.getItem(key)||'[]')}catch(e){tasks=[]}let seed=[];try{seed=JSON.parse(seedEl.textContent||'[]');if(typeof seed==='string')seed=JSON.parse(seed)}catch(e){seed=[]}if(!Array.isArray(seed))seed=[];const known=new Set(tasks.map(t=>t.id));seed.forEach(t=>{if(!known.has(t.id))tasks.push(t)});if(!tasks.length)tasks=[{id:'pmp-calendar-created-2026-09-14',title:'Création du calendrier privé des tâches',dueDate:'2026-09-14',owner:'assistant',priority:'normal',type:'standard',notes:'Page et interface du calendrier préparées dans une copie du thème.',done:true,createdAt:'2026-09-14T00:00:00.000Z',completedAt:'2026-09-14T00:00:00.000Z'}];
  let month=new Date(),view='calendar',query='',owner='all',status='open';const $=s=>root.querySelector(s),$$=s=>[...root.querySelectorAll(s)],save=()=>localStorage.setItem(key,JSON.stringify(tasks));save();
  const iso=d=>{const y=d.getFullYear(),m=String(d.getMonth()+1).padStart(2,'0'),day=String(d.getDate()).padStart(2,'0');return `${y}-${m}-${day}`},today=iso(new Date()),fmt=d=>d?new Intl.DateTimeFormat('fr-CA',{day:'numeric',month:'short',year:'numeric'}).format(new Date(d+'T12:00:00')):'—',esc=s=>String(s||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  function filtered(){return tasks.filter(t=>{if(query&&!`${t.title} ${t.notes||''}`.toLowerCase().includes(query))return false;if(owner!=='all'&&t.owner!==owner)return false;if(status==='open'&&t.done)return false;if(status==='done'&&!t.done)return false;if(view==='today'&&t.dueDate!==today)return false;if(view==='permanent'&&t.type!=='permanent')return false;if(view==='completed'&&!t.done)return false;return true})}
  function stats(){const ym=today.slice(0,7);$('[data-today-count]').textContent=tasks.filter(t=>t.dueDate===today&&!t.done).length;$('[data-all-count]').textContent=tasks.filter(t=>!t.done).length;$('[data-permanent-count]').textContent=tasks.filter(t=>t.type==='permanent'&&!t.done).length;$('[data-completed-count]').textContent=tasks.filter(t=>t.done).length;$('[data-stat-today]').textContent=tasks.filter(t=>t.dueDate===today&&!t.done).length;$('[data-stat-followups]').textContent=tasks.filter(t=>t.type==='followup'&&!t.done).length;$('[data-stat-permanent]').textContent=tasks.filter(t=>t.type==='permanent'&&!t.done).length;$('[data-stat-completed]').textContent=tasks.filter(t=>t.done&&(t.completedAt||'').slice(0,7)===ym).length}
  function renderCalendar(){const grid=$('[data-calendar-grid]'),y=month.getFullYear(),m=month.getMonth(),first=new Date(y,m,1),start=new Date(y,m,1-((first.getDay()+6)%7));$('[data-month-label]').textContent=new Intl.DateTimeFormat('fr-CA',{month:'long',year:'numeric'}).format(first);grid.innerHTML='';const data=filtered();for(let i=0;i<42;i++){const d=new Date(start);d.setDate(start.getDate()+i);const ds=iso(d),day=document.createElement('div');day.className='pmp-tasks__day'+(d.getMonth()!==m?' is-outside':'')+(ds===today?' is-today':'');const matches=data.filter(t=>t.dueDate===ds||t.type==='permanent'&&d.getDay()===1).slice(0,4);day.innerHTML=`<span class="pmp-tasks__date">${d.getDate()}</span>${matches.map(t=>`<button type="button" class="pmp-tasks__chip${t.done?' is-done':''}" data-id="${esc(t.id)}" data-type="${esc(t.type)}" data-owner="${esc(t.owner)}">${esc(t.title)}</button>`).join('')}${data.filter(t=>t.dueDate===ds).length>4?`<span class="pmp-tasks__more">+${data.filter(t=>t.dueDate===ds).length-4}</span>`:''}`;day.addEventListener('dblclick',e=>{if(e.target===day||e.target.classList.contains('pmp-tasks__date'))openTask(null,ds)});grid.append(day)}}
  function renderList(){const list=$('[data-task-list]'),data=filtered().sort((a,b)=>(a.done-b.done)||String(a.dueDate||'9999').localeCompare(String(b.dueDate||'9999')));list.innerHTML=data.map(t=>`<article class="pmp-tasks__row" data-id="${esc(t.id)}"><div class="pmp-tasks__row-title"><input type="checkbox" ${t.done?'checked':''} data-toggle aria-label="Terminer"><span><strong>${esc(t.title)}</strong><small>${esc(t.notes||'')}</small></span></div><span>${fmt(t.dueDate)}</span><span class="pmp-tasks__badge">${t.owner==='assistant'?'Assistant':'Daniel'}</span><span class="pmp-tasks__badge ${t.done?'is-done':t.type==='permanent'?'is-permanent':''}">${t.done?'Terminée':t.type==='permanent'?'Permanente':'À faire'}</span></article>`).join('');$('[data-empty]').hidden=data.length>0}
  function render(){stats();const cal=view==='calendar';$('[data-calendar-view]').hidden=!cal;$('[data-list-view]').hidden=cal;const titles={calendar:'Calendrier',today:"Aujourd’hui",all:'Toutes les tâches',permanent:'Tâches permanentes',completed:'Terminées'};$('[data-view-title]').textContent=titles[view];$$('[data-view]').forEach(b=>b.classList.toggle('is-active',b.dataset.view===view));cal?renderCalendar():renderList()}
  const dialog=$('[data-task-dialog]'),form=$('[data-task-form]');function openTask(task,date){form.reset();form.elements.id.value=task?.id||'';form.elements.title.value=task?.title||'';form.elements.dueDate.value=task?.dueDate||date||today;form.elements.owner.value=task?.owner||'daniel';form.elements.priority.value=task?.priority||'normal';form.elements.type.value=task?.type||'standard';form.elements.notes.value=task?.notes||'';form.elements.done.checked=Boolean(task?.done);$('[data-dialog-title]').textContent=task?'Modifier la tâche':'Nouvelle tâche';$('[data-delete-task]').hidden=!task;dialog.showModal()}
  $('[data-open-task]').addEventListener('click',()=>openTask());$$('[data-view]').forEach(b=>b.addEventListener('click',()=>{view=b.dataset.view;render()}));$('[data-search]').addEventListener('input',e=>{query=e.target.value.trim().toLowerCase();render()});$('[data-owner-filter]').addEventListener('change',e=>{owner=e.target.value;render()});$('[data-status-filter]').addEventListener('change',e=>{status=e.target.value;render()});$('[data-prev-month]').addEventListener('click',()=>{month=new Date(month.getFullYear(),month.getMonth()-1,1);render()});$('[data-next-month]').addEventListener('click',()=>{month=new Date(month.getFullYear(),month.getMonth()+1,1);render()});$('[data-current-month]').addEventListener('click',()=>{month=new Date();render()});
  root.addEventListener('click',e=>{const chip=e.target.closest('.pmp-tasks__chip'),row=e.target.closest('.pmp-tasks__row');if(chip)openTask(tasks.find(t=>t.id===chip.dataset.id));if(row){const task=tasks.find(t=>t.id===row.dataset.id);if(e.target.matches('[data-toggle]')){task.done=e.target.checked;task.completedAt=task.done?new Date().toISOString():null;save();render()}else openTask(task)}});
  $('[data-save-task]').addEventListener('click',e=>{e.preventDefault();if(!form.reportValidity())return;const data=Object.fromEntries(new FormData(form)),existing=tasks.find(t=>t.id===data.id),wasDone=existing?.done;const task={id:data.id||`task-${Date.now()}`,title:data.title.trim(),dueDate:data.dueDate,owner:data.owner,priority:data.priority,type:data.type,notes:data.notes.trim(),done:form.elements.done.checked,createdAt:existing?.createdAt||new Date().toISOString(),completedAt:form.elements.done.checked?(wasDone?existing.completedAt:new Date().toISOString()):null};if(existing)tasks=tasks.map(t=>t.id===task.id?task:t);else tasks.push(task);save();dialog.close();render()});
  $('[data-delete-task]').addEventListener('click',()=>{const id=form.elements.id.value;if(id&&confirm('Supprimer cette tâche ?')){tasks=tasks.filter(t=>t.id!==id);save();dialog.close();render()}});$('[data-open-import]').addEventListener('click',()=>root.querySelector('[data-import-dialog]').showModal());$('[data-export]').addEventListener('click',()=>{const blob=new Blob([JSON.stringify(tasks,null,2)],{type:'application/json'}),a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=`pmp-taches-${today}.json`;a.click();URL.revokeObjectURL(a.href)});$('[data-import]').addEventListener('change',async e=>{const file=e.target.files[0];if(!file)return;try{const incoming=JSON.parse(await file.text());if(!Array.isArray(incoming))throw new Error();tasks=incoming;save();root.querySelector('[data-import-dialog]').close();render()}catch(err){alert('Fichier de tâches invalide.')}});render()})();

  } catch(e) { console.error(e); }
})();
})();
